/**
 * CV-related constants
 */

/**
 * Default accent color for CV templates when not specified
 */
export const DEFAULT_ACCENT_COLOR = '#00B48A';

/**
 * Default CV template ID when not specified
 */
export const DEFAULT_TEMPLATE_ID = 'classic';

/**
 * Default accent colors per template
 */
export const TEMPLATE_ACCENT_DEFAULTS: Record<string, string> = {
  classic: DEFAULT_ACCENT_COLOR,
  september: DEFAULT_ACCENT_COLOR,
  onepage: DEFAULT_ACCENT_COLOR,
  ciblijob: '#00B48A',
  'json-elegant': DEFAULT_ACCENT_COLOR,
  'json-flat': DEFAULT_ACCENT_COLOR,
  'json-executive-slate': DEFAULT_ACCENT_COLOR,
  'json-modern-classic': DEFAULT_ACCENT_COLOR,
  'json-stackoverflow': DEFAULT_ACCENT_COLOR,
};
